<template>
    <div>
        <div class="columns toolbar-box">
            <div class="column is-9">
                <div class="columns">
                    <div class="column is-4">
                        <h1 class="title is-3 between-center">
                            <span>Global Settings</span>
                        </h1>
                    </div>
                    <div class="column is-2">
                        <o-field>
                            <o-autocomplete
                                v-model="nameSelect.name"
                                placeholder="Name"
                                :keep-first="nameSelect.keepFirst"
                                :data="nameSelect.data"
                                field="user.first_name"
                                icon="search"
                                @select="option => nameSelect.selected = option"
                                max-results="1000"
                            ></o-autocomplete>
                        </o-field>
                    </div>
                    <div class="column is-2">
                        <o-field>
                            <o-autocomplete
                                v-model="citySelect.name"
                                placeholder="City"
                                :keep-first="citySelect.keepFirst"
                                :data="citySelect.data"
                                field="user.last_name"
                                icon="search"
                                @select="option => citySelect.selected = option"
                                max-results="1000"
                            ></o-autocomplete>
                        </o-field>
                    </div>
                    <div class="column is-2">
                        <o-field>
                            <o-autocomplete
                                v-model="zipSelect.name"
                                placeholder="Zip code"
                                :keep-first="zipSelect.keepFirst"
                                :data="zipSelect.data"
                                field="user.last_name"
                                icon="search"
                                @select="option => zipSelect.selected = option"
                                max-results="1000"
                            ></o-autocomplete>
                        </o-field>
                    </div>
                    <div class="column is-2">
                        <o-field>
                            <o-select placeholder="State" v-model="selectedState" :expanded="true">
                                <option
                                    v-for="option in options"
                                    :value="option.id"
                                    :key="option.id">
                                    {{ option.first_name }}
                                </option>
                            </o-select>
                        </o-field>
                    </div>
                </div>
            </div>
            <div class="column is-3">
                <div class="field is-grouped is-grouped-right">
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                </div>
            </div>
        </div>

        <o-table
            :data="tableData"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :checkable="isCheckable"
            :loading="isLoading"
            :mobile-cards="hasMobileCards"
            :paginated="isPaginated"
            :per-page="perPage"
            :pagination-simple="isPaginationSimple"
            default-sort="user.first_name"
            :selected.sync="selected"
            :checked-rows="checkedRows"
            @update:checkedRows="$event => checkedRows = $event">

            <template>
                <o-table-column #default="{ row }" field="id" label="ID" width="40" sortable numeric>
                    {{ row.id }}
                </o-table-column>

                <o-table-column #default="{ row }" field="user.first_name" label="First Name" sortable>
                    {{ row.user.first_name }}
                </o-table-column>

                <o-table-column #default="{ row }" field="user.last_name" label="Last Name" sortable>
                    {{ row.user.last_name }}
                </o-table-column>

                <o-table-column #default="{ row }" field="date" label="Date" sortable>
                    <span class="tag is-success">
                        {{ new Date(row.date).toLocaleDateString() }}
                    </span>
                </o-table-column>

            </template>

            <template #empty>
              <div class="has-text-centered">
                This table is empty!
              </div>
            </template>
        </o-table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                    {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                    {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                    {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                    {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                    // ...
                ],
                nameSelect: {
                    data: [
                        {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                        {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                        {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                        {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                        {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                        // ...
                    ],
                    keepFirst: true,
                    name: '',
                    selected: null
                },
                citySelect: {
                    data: [
                        {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                        {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                        {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                        {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                        {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                        // ...
                    ],
                    keepFirst: true,
                    name: '',
                    selected: null
                },
                zipSelect: {
                    data: [
                        {"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016-10-15 13:43:27","gender":"Male"},
                        {"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016-12-15 06:00:53","gender":"Male"},
                        {"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016-04-26 06:26:28","gender":"Female"},
                        {"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016-04-10 10:28:46","gender":"Male"},
                        {"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016-12-06 14:38:38","gender":"Female"},
                        // ...
                    ],
                    keepFirst: true,
                    name: '',
                    selected: null
                },
                options: [
                    {"id":1,"first_name":"Jesse"},
                    {"id":2,"first_name":"John"},
                    {"id":3,"first_name":"Tina"},
                    {"id":4,"first_name":"Clarence"},
                    {"id":5,"first_name":"Anne"},
                    // ...
                ],
                checkedRows: [],
                selected: {},
                isBordered: false,
                isStriped: true,
                isNarrowed: false,
                isCheckable: true,
                isLoading: false,
                hasMobileCards: true,
                isPaginated: true,
                isPaginationSimple: false,
                perPage: 10,
                selectedState: null,
            }
        },

        methods: {
            resetFilters() {
                this.nameSelect.name = this.citySelect.name = this.zipSelect.name = this.selectedState = null
            },
            clearSelected() {
                this.selected = {}
            },
            clearCheckedRows() {
                this.checkedRows = []
            },
            confirmCustomDelete() {
                this.$swal.fire({
                    title: 'Deleting contact',
                    text: 'Are you sure you want to <strong>delete</strong> this contact? This action cannot be undone.',
                    confirmText: 'Delete Contact',
                    icon: 'error',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$swal.fire('Contact deleted!')
                    }
                })
            }
        },
        computed: {
            filteredDataArray() {
                return this.arrayExample.data.filter((option) => {
                    return option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.arrayExample.name.toLowerCase()) >= 0
                })
            },
            isResetFiltersButtonVisible () {
                return this.nameSelect.name || this.citySelect.name || this.zipSelect.name || this.selectedState
            },
            isDeleteSelectedButtonVisible () {
                return this.checkedRows.length
            },
        }
    }
</script>